import { useMemo } from 'react'
import { useQuery, ApolloError } from '@apollo/client'
import statusShippedQuery from '@Orders/OrderDetailsPage/Queries/statusShippedQuery'
import {
    shipmentLines_shipment,
    shipmentLines_shipment_shipmentLines_items as ItemsType,
    shipmentLines_shipment_shipmentLines_cursor,
} from '@Orders/OrderDetailsPage/Queries/__generated__/shipmentLines'
import {
    initialRevisionValues,
    checkEmptyValues,
} from '@Orders/OrderDetailsPage/Status/logic'

import { ShipmentLineRecordType } from './types'

export const PLACEMENT = 'shipment-table-order-detail-page'

export const PLACEMENT_PART_VIEWER =
    'shipment-table-part-viewer-order-detail-page'

export const useFormatShipmentLineData = (
    ShipmentLine: ItemsType,
): ShipmentLineRecordType => {
    const {
        id,
        boundingBox,
        dfmFeedback,
        erpMoldId,
        holes,
        inspectionDocuments,
        inspectionTypes,
        materialDetails,
        processes,
        processName,
        processNames,
        quantity,
        revision,
        totalQuantity,
        quoteModelRevisionAttachment,
        woAvailableToShow,
    } = ShipmentLine

    const materialName = materialDetails?.name
    const splitMaterialName = materialName
        ? materialName?.split('(', 1)[0]?.trim()
        : null

    return {
        id,
        key: id,
        boundingBox,
        dfmFeedback: checkEmptyValues(dfmFeedback),
        erpMoldId,
        holes: checkEmptyValues(holes),
        inspectionDocuments: checkEmptyValues(inspectionDocuments),
        inspectionTypes,
        material: materialDetails,
        materialName: splitMaterialName,
        processes: checkEmptyValues(processes),
        processName: processName || '',
        processNames: checkEmptyValues(processNames),
        quantity,
        revision,
        totalQuantity,
        twoDdrawing: quoteModelRevisionAttachment,
        woAvailableToShow,
    }
}

export const useShipmentLinesData = (
    shipment: shipmentLines_shipment | undefined,
) =>
    useMemo(
        () =>
            shipment?.shipmentLines.items &&
            shipment.shipmentLines.items.map(useFormatShipmentLineData),
        [shipment],
    )

export const useShipmentData = (
    shipmentId: string,
    limit: number,
    cursor?: shipmentLines_shipment_shipmentLines_cursor,
): {
    data?: {
        shipment: shipmentLines_shipment
    }
    loading: boolean
    error?: ApolloError | undefined
} => {
    const variables: {
        id: string
        limit: number
        cursor?: shipmentLines_shipment_shipmentLines_cursor
    } = {
        id: shipmentId,
        limit: limit,
    }

    if (cursor) {
        variables.cursor = cursor
    }

    return useQuery(statusShippedQuery, {
        variables: variables,
        skip: !shipmentId,
    })
}

export const getOffsetOfFirstAndLastRecord = (
    pageNumber: number | undefined,
    numberOfRecordsonPage: number | undefined,
    paginationLimit: number,
) => {
    const offsetOfFirstRecordOfPage = pageNumber
        ? (pageNumber - 1) * paginationLimit + 1
        : 0
    const offsetOfLastRecordOfPage = numberOfRecordsonPage
        ? offsetOfFirstRecordOfPage + numberOfRecordsonPage - 1
        : 0

    return { offsetOfFirstRecordOfPage, offsetOfLastRecordOfPage }
}

export const intialValues = {
    processNames: [],
    quantity: 0,
    boundingBox: null,
    inspectionDocuments: [],
    inspectionTypes: [],
    processName: '',
    material: null,
    twoDdrawing: null,
    processes: [],
    holes: [],
    dfmFeedback: [],
    revision: initialRevisionValues,
    totalQuantity: 0,
    materialName: '',
    woAvailableToShow: false,
    id: '',
    erpMoldId: '',
}
